/* eslint-disable */
/* eslint-disable no-restricted-globals, no-undef */
import React, { useState, useEffect } from 'react';
import {
  Box,
  Heading,
  VStack,
  HStack,
  Input,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  IconButton,
  useToast,
  Flex,
  useColorModeValue
} from '@chakra-ui/react';
import { DeleteIcon, EditIcon } from '@chakra-ui/icons';
import AdminNavTop from '../AdminNavTop';
import axios from 'axios';
import { useModalToast } from "../../context/GlobalModalToast";

const CategoryManager = () => {
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState('');
  const [loading, setLoading] = useState(true);
  const { toast, confirm, prompt } = useModalToast();
  const token = JSON.parse(localStorage.getItem('user'))?.token || "";

  const fetchCategories = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/categories`);
      setCategories(res.data);
    } catch (err) {
      toast({ title: 'Failed to fetch categories', status: 'error' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleAdd = async () => {
    if (!newCategory.trim()) return;
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/categories`, 
        { name: newCategory },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setCategories([...categories, res.data]);
      setNewCategory('');
      toast({ title: 'Category added', status: 'success' });
    } catch (err) {
      toast({ title: err.response?.data?.message || 'Failed to add category', status: 'error' });
    }
  };

  const handleDelete = async (id) => {
    { const _c = await confirm({ title: "Confirm", description: "Are you sure you want to delete this category?", status: "warning" }); if (!_c) return; }
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/api/categories/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCategories(categories.filter(c => c._id !== id));
      toast({ title: 'Category deleted', status: 'success' });
    } catch (err) {
      toast({ title: 'Failed to delete category', status: 'error' });
    }
  };

  const handleEdit = async (cat) => {
    const newName = await prompt({
      title: "Edit Category",
      description: "Enter the new category name:",
      placeholder: "e.g. Data Science",
    });
    if (!newName || !newName.trim() || newName.trim() === cat.name) return;

    try {
      const res = await axios.put(`${process.env.REACT_APP_API_URL}/api/categories/${cat._id}`, 
        { name: newName },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setCategories(categories.map(c => c._id === cat._id ? res.data : c));
      toast({ title: 'Category updated', status: 'success' });
    } catch (err) {
      toast({ title: err.response?.data?.message || 'Failed to update category', status: 'error' });
    }
  };

  const bgMain = useColorModeValue("gray.50", "gray.900");
  const cardBg = useColorModeValue("white", "gray.800");
  const cardBorder = useColorModeValue("gray.100", "gray.700");
  const textMain = useColorModeValue("gray.800", "gray.100");
  const tableHeaderBg = useColorModeValue("gray.50", "gray.700");
  const inputBg = useColorModeValue("white", "gray.700");
  const inputBorder = useColorModeValue("purple.200", "purple.500");
  const hoverBg = useColorModeValue("purple.50", "whiteAlpha.100");
  const emptyText = useColorModeValue("gray.500", "gray.400");

  return (
    <Box mx="auto" w="full" minH="100vh" bg={bgMain} pb={10}>
      <AdminNavTop />
      <Box maxW="800px" mx="auto" px={6} pt="100px">
        <Box className="glass-card" borderRadius="2xl" p={8} bg={cardBg} boxShadow="var(--shadow-premium)" border="1px solid" borderColor={cardBorder}>
          <Heading size="md" mb={6} color={textMain} fontWeight="800">
            🏷️ Manage Course Categories
          </Heading>
          
          <HStack mb={8}>
            <Input 
              value={newCategory} 
              onChange={(e) => setNewCategory(e.target.value)} 
              placeholder="e.g. Data Science" 
              borderRadius="xl"
              bg={inputBg}
              borderColor={inputBorder}
            />
            <Button onClick={handleAdd} colorScheme="purple" borderRadius="xl">Add Category</Button>
          </HStack>

          <Box overflowX="auto" borderRadius="xl" border="1px solid" borderColor={cardBorder}>
            <Table variant="simple">
              <Thead bg={tableHeaderBg}>
                <Tr>
                  <Th color={textMain}>Category Name</Th>
                  <Th textAlign="right" color={textMain}>Actions</Th>
                </Tr>
              </Thead>
              <Tbody>
                {categories.map((cat) => (
                  <Tr key={cat._id} _hover={{ bg: hoverBg }} transition="all 0.2s">
                    <Td fontWeight="bold" color={textMain}>{cat.name}</Td>
                  <Td textAlign="right">
                    <HStack justify="flex-end" spacing={2}>
                      <IconButton 
                        icon={<EditIcon />} 
                        colorScheme="blue" 
                        variant="ghost" 
                        onClick={() => handleEdit(cat)} 
                        aria-label="Edit Category"
                      />
                      <IconButton 
                        icon={<DeleteIcon />} 
                        colorScheme="red" 
                        variant="ghost" 
                        onClick={() => handleDelete(cat._id)} 
                        aria-label="Delete Category"
                      />
                    </HStack>
                  </Td>
                </Tr>
              ))}
                {categories.length === 0 && !loading && (
                  <Tr>
                    <Td colSpan={2} textAlign="center" color={emptyText}>No categories found.</Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default CategoryManager;
